import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Chapters } from "@/components/Chapters";
import { Chauffeur } from "@/components/Chauffeur";
import { Fleet } from "@/components/Fleet";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Chapters />
      <Chauffeur />
      <Fleet />
      <Booking />
      <Footer />
    </main>
  );
}
